import { useState, useEffect } from "react";
import { ContactAPI, CategoryAPI } from "../../../api";
import "./index.css";

const data = {
	full_name: "",
	phone_number: "",
	email_address: "",
	service: "",
};

const ContactForm = () => {
	const [formData, setFormData] = useState(data);
	const [categories, setCategories] = useState([]);

	useEffect(() => {
		CategoryAPI.getAllCategories()
			.then((res) => setCategories(res.data))
			.catch((err) => console.error(err));
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const payload = formData;
		try {
			await ContactAPI.submitContactForm(payload);
			alert("Message sent!");
			setFormData({
				full_name: "",
				phone_number: "",
				email_address: "",
				service: "",
			});
		} catch (err) {
			console.error(err);
			alert("Something went wrong.");
		}
	};

	return (
		<div className="card form-container">
			<div className="card-body">
				<form className="contact-form" onSubmit={handleSubmit}>
					<p>
						Please fill out the form and we will get in touch with you shortly
					</p>

					<div className="contact-input d-flex flex-column my-3">
						<span>Full Name</span>
						<input
							type="text"
							name="full_name"
							value={formData.full_name}
							onChange={handleChange}
							required
						/>
					</div>

					<div className="contact-input d-flex flex-column my-3">
						<span>Phone Number</span>
						<input
							type="text"
							name="phone_number"
							value={formData.phone_number}
							onChange={handleChange}
							required
						/>
					</div>

					<div className="contact-input d-flex flex-column my-3">
						<span>Email Address</span>
						<input
							type="email"
							name="email_address"
							value={formData.email_address}
							onChange={handleChange}
							required
						/>
					</div>

					<div className="contact-input d-flex flex-column my-3">
						<span>Choose a service</span>
						<select
							name="service"
							value={formData.service}
							onChange={handleChange}
							required
						>
							<option value="">Choose</option>
							{categories.map((category, index) => (
								<option key={index} value={category.title}>
									{category.title}
								</option>
							))}
						</select>
					</div>

					<button type="submit" className="btn mt-2">
						Submit
					</button>
				</form>
			</div>
		</div>
	);
};

export default ContactForm;
